import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../ThemeContext';
import './Features.css';

const REVEAL = { hidden: { opacity: 0, y: 8 }, visible: { opacity: 1, y: 0 } };
const T = { duration: 0.52, ease: [0.22, 1, 0.36, 1] };
const VIEWPORT = { once: true, amount: 0.15 };

const Phone = ({ src, alt }) => (
  <div className="phone-frame">
    <div className="phone-notch" />
    <div className="phone-inner">
      <img src={src} alt={alt} />
    </div>
  </div>
);

const FeatureBlock = ({ eyebrow, title, body, screen, alt, reverse, children }) => (
  <motion.div
    className={`feature-block ${reverse ? 'reverse' : ''}`}
    variants={REVEAL}
    initial="hidden"
    whileInView="visible"
    viewport={VIEWPORT}
    transition={T}
  >
    <div className="feature-text">
      <div className="eyebrow">{eyebrow}</div>
      <h3>{title}</h3>
      <p>{body}</p>
      {children}
    </div>
    <div className="feature-visual">
      <Phone src={screen} alt={alt} />
    </div>
  </motion.div>
);

const Features = () => {
  const { theme } = useTheme();
  const base = process.env.PUBLIC_URL;
  const home  = `${base}/assets/app-${theme}-home.png`;
  const stats = `${base}/assets/app-${theme}-stats.png`;

  return (
    <section className="features" id="features">
      <motion.div
        className="features-header"
        variants={REVEAL}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        transition={T}
      >
        <div className="eyebrow">What's inside</div>
        <h2>Built around<br />the way you live with your dog.</h2>
      </motion.div>

      <FeatureBlock
        eyebrow="01 · Quick log"
        title="One tap to log anything."
        body="Poop, pee, meal, walk, water, medicine. The six things that fill your day are the six big buttons on your home screen. Add a note if you want — most days, you won't need to."
        screen={home}
        alt="PawPrints home screen"
      />

      <FeatureBlock
        eyebrow="02 · Insights"
        title="A week, in one breath."
        body="Quiet bar charts that show bathroom habits, meal cadence, and walks across seven days, thirty, or three months. Spot the patterns. Catch the changes early."
        screen={stats}
        alt="PawPrints stats screen"
        reverse
      />
    </section>
  );
};

export default Features;
